export default {
  shareTitle: '分享',
  download: '下载',
  welcome: '欢迎您',
  invitation: '诚挚邀请您参观',
  session: '第{num}届',
  scanQrCode: '长按识别获取参观门票',
  cancel: '取 消',
  downloadSuccess: '下载成功!'
}
